import { ROUTES } from 'constants/routes'
import { Icon } from 'gu-ui-kit'
import React from 'react'
import Wallets from 'modules/Finance/Wallets'
import Invoices from 'modules/Finance/Invoices'

const defaultNavigationConfig = ({ user = {} }) =>
  !user?.id
    ? []
    : [
        {
          path: ROUTES.SERVICES,
          key: 'services_list',
          label_key: 'common::nav_menu.advertisement_networks',
          icon: (
            <Icon
              name={'gramophone'}
              size={'m'}
            />
          ),
        },
        {
          path: ROUTES.FINANCE,
          key: 'finance',
          label_key: 'common::nav_menu.finance',
          icon: (
            <Icon
              name={'card'}
              size={'m'}
            />
          ),
          routes: [
            {
              exact: true,
              path: ROUTES.FINANCE_WALLETS,
              key: 'finance/wallets',
              label_key: 'finance::navigation.wallets',
              component: Wallets,
              icon: (
                <Icon
                  name={'money'}
                  size={'m'}
                />
              ),
            },
            {
              exact: true,
              path: ROUTES.FINANCE_INVOICES,
              key: 'finance/invoices',
              label_key: 'finance::navigation.invoices',
              component: Invoices,
              icon: (
                <Icon
                  name={'doc'}
                  size={'m'}
                />
              ),
            },
            {
              exact: true,
              path: ROUTES.FINANCE_PAYMENT_PROFILES,
              key: 'finance/payment-profiles',
              label_key: 'finance::navigation.payment_profiles',
              icon: (
                <Icon
                  name={'user'}
                  size={'m'}
                />
              ),
            },
            {
              exact: false,
              key: 'finance/promised-payment',
              label_key: 'finance::navigation.promised_payment',
              path: ROUTES.FINANCE_PROMISED_PAYMENT,
              icon: (
                <Icon
                  name={'time-clock'}
                  size={'m'}
                />
              ),
            },
          ],
        },
        {
          path: ROUTES.STATISTICS,
          exact: true,
          label_key: 'statistics::navigation.main',
          key: 'statistics_main',
          icon: (
            <Icon
              name={'statistics'}
              size="m"
            />
          ),
        },
        ...(user?.is_agency_account_available
          ? [
              {
                path: ROUTES.AGENCY,
                label_key: 'common::nav_menu.agency_dashboard',
                key: 'agency',
                icon: (
                  <Icon
                    name={'profile'}
                    size={'m'}
                  />
                ),
                routes: [
                  {
                    path: ROUTES.AGENCY_REQUESTS,
                    exact: true,
                    key: 'agency/requests',
                    icon: (
                      <Icon
                        name={'user-add'}
                        size={'m'}
                      />
                    ),
                    label_key: 'agency::navigation.requests',
                  },
                  {
                    path: ROUTES.AGENCY_CLIENTS,
                    exact: true,
                    key: 'agency/clients',
                    icon: (
                      <Icon
                        name={'users'}
                        size={'m'}
                      />
                    ),
                    label_key: 'agency::navigation.clients',
                  },
                  {
                    path: ROUTES.AGENCY,
                    exact: true,
                    key: 'agency/main',
                    icon: (
                      <Icon
                        name={'heart'}
                        size="m"
                      />
                    ),
                    label_key: 'agency::navigation.my_agency',
                  },
                ],
              },
            ]
          : []),
        ...(user?.is_referral_program_available
          ? [
              {
                exact: true,
                key: 'referral_program',
                label_key: 'referral::navigation.affiliate_account',
                icon: (
                  <Icon
                    name={'profile-window'}
                    size={'m'}
                  />
                ),
                routes: [
                  {
                    path: ROUTES.REFERRAL_LINKS,
                    exact: true,
                    key: 'referral/links',
                    icon: (
                      <Icon
                        name={'copy-link'}
                        size={'m'}
                      />
                    ),
                    label_key: 'referral::navigation.referral-links',
                  },
                  {
                    path: ROUTES.REFERRAL_CLIENTS,
                    exact: true,
                    key: 'referral/referral-clients',
                    icon: (
                      <Icon
                        name={'users'}
                        size={'m'}
                      />
                    ),
                    label_key: 'referral::navigation.referral-clients',
                  },
                  {
                    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
                    key: 'referral/payout-profiles',
                    label_key: 'referral::navigation.payout-profiles',
                    icon: (
                      <Icon
                        name={'money-cashUp'}
                        size={'m'}
                      />
                    ),
                  },
                ],
              },
            ]
          : [
              {
                exact: true,
                key: 'referral_program',
                label_key: 'referral::navigation.referral_program',
                icon: (
                  <Icon
                    name={'two-users'}
                    size={'m'}
                  />
                ),
                routes: [
                  {
                    exact: true,
                    path: ROUTES.REFERRALS,
                    key: 'referrals/referrals',
                    label_key: 'referral::navigation.referrals',
                    icon: (
                      <Icon
                        name={'users'}
                        size={'m'}
                      />
                    ),
                  },
                  {
                    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
                    key: 'referral/payout-profiles',
                    label_key: 'referral::navigation.payout-profiles',
                    icon: (
                      <Icon
                        name={'input'}
                        size={'m'}
                      />
                    ),
                  },
                ],
              },
            ]),
        //@TODO вернем на следующем этапе когда меню в финансах научится раздвигаться вправо для 4ого уровня вложенности
        /*{
        key: 'other',
        label_key: 'common::nav_menu.other',
        routes: [*/

        // {
        //   path: ROUTES.PARTNERS,
        //   label_key: 'common::nav_menu.partners',
        //   key: 'partners',
        //   icon: <Icon name="money" size="m" />,
        // },
        // {
        //   path: ROUTES.ACCOUNTS_MARKETPLACE,
        //   label_key: 'common::nav_menu.accounts_marketplace',
        //   key: 'accounts_marketplace',
        //   icon: <Icon name="user-add" size="m" />,
        // },

        // {
        //   path: ROUTES.FINANCE,
        //   key: 'finance/wallets',
        //   label_key: 'common::nav_menu.finance',
        //   icon: <Icon name="money" size="m" />,
        //   exact: false,
        //   routes: [
        //     {
        //       exact: true,
        //       path: ROUTES.FINANCE_WALLETS,
        //       key: 'finance/wallets',
        //       label_key: 'common::nav_menu.cards',
        //       icon: <Icon name="card" size="m" />,
        //     },
        //     {
        //       exact: true,
        //       path: ROUTES.FINANCE_PAYMENT_PROFILES,
        //       key: 'finance/payment-profiles',
        //       label_key: 'user::navigation.payment-profiles',
        //       icon: <Icon name={'user'} size={'m'} />,
        //     },
        //     {
        //       exact: true,
        //       label_key: 'common::nav_menu.promised_payment_request',
        //       key: 'finance/promised_payment_request',
        //       path: ROUTES.FINANCE_PROMISED_PAYMENT_REQUEST,
        //       icon: <Icon name={'orders'} size={'m'} />,
        //     },
        //   ],
        // },
        /*],
      },*/
      ]

export default defaultNavigationConfig
